import Vue from 'vue'

/**
 * How to use:
 * 
 * @uses  v-on-hover-color:[:color]
 * @param {String} color - the color will appear on hover
 * 
 * @example
 * <div v-on-hover-color="{color: '#6562f6'}">
 *  some text
 * </div>
 * <div v-on-hover-color="{color: '#6562f6', disabled: true}">
 *  some text
 * </div>
 */

Vue.directive('on-hover-color', {
  inserted(el, binding, vnode, old) {
    
    el.addEventListener('mouseenter', () => {
      const disabled = binding.value.disabled !== undefined ? binding.value.disabled : false
      if (disabled) return
      el.style['color'] = `${binding.value.color}`
    })

    el.addEventListener('mouseleave', () => {
      el.style['color'] = 'inherit'
    })
  },
})